export default __webpack_public_path__ + "static/media/about.0dfac8ff.jpg";